import {IHttpHandler} from "./IHttpHandler";
import {HttpEvent, HttpEventType, HttpRequest} from "@angular/common/http";
import {AppEventBus} from "../../../common/event-buses/app.event-bus";
import {ProgressTrackableItem} from "../../../common/interfaces/domain/ProgressTrackableItem";
import {AppEvent} from "../../../common/event-buses/AppEvent";
import {AppEventName} from "../../../common/event-buses/AppEventName";

export class ProgressTrackingHandler implements IHttpHandler {

  constructor(private readonly appEventBus: AppEventBus) {
  }

  canHandleRequest(request: HttpRequest<any>): boolean {
    const url = request.url;

    if(url.indexOf('ui-build-info') > -1) {
      return false;
    }

    if(url.indexOf('/users/exist') > -1) {
      return false;
    }

    return true;
  }

  canHandleResponse(request: HttpRequest<any>, event: HttpEvent<any>): boolean {
    const url = request.url;

    if(url.indexOf('ui-build-info') > -1) {
      return false;
    }

    if(url.indexOf('/users/exist') > -1) {
      return false;
    }

    if(event.type !== HttpEventType.Response) {
      return false;
    }

    return true;
  }

  canHandleError(request: HttpRequest<any>, event: HttpEvent<any>): boolean {
    const url = request.url;

    if(url.indexOf('ui-build-info') > -1) {
      return false;
    }

    if(url.indexOf('/users/exist') > -1) {
      return false;
    }

    return true;
  }

  handleRequest(request: HttpRequest<any>): HttpRequest<any> {
    const url = request.url;
    const item: ProgressTrackableItem = {
      key: url,
      fromWebsocket: false,
    };

    this.appEventBus.dispatch(new AppEvent(AppEventName.AddProgressTrackableItem, item));

    return request;
  }

  handleResponse(request: HttpRequest<any>, event: HttpEvent<any>): HttpEvent<any> {
    const url = request.url;
    const item: ProgressTrackableItem = {
      key: url,
      fromWebsocket: false,
    };

    setTimeout(() => {
      this.appEventBus.dispatch(new AppEvent(AppEventName.RemoveProgressTrackableItem, item));
    }, 2000);

    return event;
  }

  handleError(request: HttpRequest<any>, error: any): void {
    const url = request.url;
    const item: ProgressTrackableItem = {
      key: url,
      fromWebsocket: false,
    };

    setTimeout(() => {
      this.appEventBus.dispatch(new AppEvent(AppEventName.RemoveProgressTrackableItem, item));
    }, 2000);
  }
}
